export class ActiveOfficeService {
  static LOCAL_STORAGE_ACTIVE_OFFICE_KEY = '3p-auth.active-office';

  /**
   * @type {number}
   */
  activeOffice;

  getActiveOffice() {
    if (this.activeOffice) {
      return this.activeOffice;
    }

    const activeOfficeFromStorage = window.localStorage.getItem(ActiveOfficeService.LOCAL_STORAGE_ACTIVE_OFFICE_KEY);
    if (activeOfficeFromStorage) {
      this.activeOffice = parseInt(activeOfficeFromStorage, 10);

      return this.activeOffice;
    }

    return undefined;
  }

  setActiveOffice(officeId) {
    this.activeOffice = officeId;
    window.localStorage.setItem(ActiveOfficeService.LOCAL_STORAGE_ACTIVE_OFFICE_KEY, officeId);
  }

  reset() {
    this.activeOffice = undefined;
    window.localStorage.removeItem(ActiveOfficeService.LOCAL_STORAGE_ACTIVE_OFFICE_KEY);
  }
}

export default new ActiveOfficeService();
